/**
 * Created by rickborst on 21/02/2017.
 */

import _ from 'lodash';

import {ViewStatuses} from 'store/actions/viewtree';

import Rail from 'models/rail';
import Image from 'models/image';

const ViewNames = {
    DASHBOARD: 'dashboard',
    COLLECTION: 'collection',
    SEARCH: 'search',
    PLAYER: 'player',
    CATCH_UP: 'catch-up',
    DISCOVER: 'discover',
    MINI_EPG: 'mini-epg',
    EPG: 'epg',
    SERIES: 'series'
};

class View {

    /**
     * Constructs the model.
     *
     * @param {Object} [options] - Options object.
     */
    constructor (options = {}) {
        let views = options.views || {};

        _.forEach(views, (view, key) => {

            view = new View(view);
            view.parentView = this;
            views[key] = view;
        });

        this.status = options.status || ViewStatuses.UNPREPARED;
        this.id = options.id || '';
        this.name = options.name || '';
        this.images = _.map(options.images || [], data => {
            return new Image(data);
        });
        this.modules = _.map(options.modules || [], data => {
            return new Rail(data);
        });
        this.views = views;
        this.parentView = options.parentView || null;
        this.apiSpecifics = options.apiSpecifics || {};

        return this;
    }
}

export {ViewNames};
export default View;


// WEBPACK FOOTER //
// ./src/js/models/view.js